<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div mat-dialog-title>
  {{ modalData.title }}
  <div *ngIf="modalData.view_status === 0" style="float: right; margin-top: -5px;">

    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()" style="float: right; margin-top: -6px;">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>


<mat-dialog-content id="modalMeasureReport" class="mat-typography" style="padding: 0px 3%;">
  <!-- free and paid report -->
  <div *ngIf="report.TEMPLATE_FREE_TYPE !== null && report.TEMPLATE_NOTFREE_TYPE" class="container">
    <div class="row justify-content-center mb-4" style="min-height: 200px;">
      <div class="col-md-6 col-12 text-center">
        <div class="height-center">
          <h5 class="text-center">รายงานผลเบื้องต้น</h5>
          <p *ngIf="report.REPORT_DES_FREE" [matTooltip]="report.REPORT_DES_FREE" matTooltipPosition="right"
            style="font-size: smaller; color: #A90088; text-decoration: underline; cursor: pointer; margin-right: 87px; margin-top: -10px;">
            คำอธิบาย</p>
          <button (click)="preliminaryReport(report.TEMPLATE_FREE_TYPE)" class="btn btn-success mt-2"
            style="color: #FFF; width: 100px; height: 40px;">
            ฟรี
          </button>
        </div>
      </div>
      <hr class="vertical d-none d-md-block d-lg-block d-xl-block">
      <hr class="horizon d-none d-block d-sm-block d-md-none">
      <div class="col-md-6 col-12 text-center">
        <div class="height-center">
          <h5 class="text-center">รายงานผลเชิงลึก</h5>
          <p *ngIf="report.REPORT_DES_NOTFREE" [matTooltip]="report.REPORT_DES_NOTFREE" matTooltipPosition="right"
            style="font-size: smaller; color: #A90088; text-decoration: underline; cursor: pointer; margin-right: 87px; margin-top: -10px;">
            คำอธิบาย</p>
          <div *ngIf="modalData.ROLE === 'user'">
            <button
              *ngIf="report.STATUS_NOTFREE_PAY === 'waiting_pay' || report.STATUS_NOTFREE_PAY === 'reject' || report.STATUS_NOTFREE_PAY === 'cancel'"
              (click)="paid()" class="btn mt-2" style="background: #DE5C8E; color: #FFF; width: 100px; height: 40px;">
              {{ report.PRICE | number }}฿
            </button>
            <button *ngIf="report.STATUS_NOTFREE_PAY === 'success'" (click)="indeptReport(report.TEMPLATE_NOTFREE_TYPE)"
              class="btn mt-2" style="background: #060E9F; color: #FFF; width: 100px; height: 40px;">
              ดู
            </button>
            <button *ngIf="report.STATUS_NOTFREE_PAY === 'waiting_confirm'" class="btn mt-2"
              style="background: #DE5C8E; color: #FFF; width: 100px; height: 40px;" disabled>
              {{ report.PRICE | number }}฿
            </button>
            <p *ngIf="report.STATUS_NOTFREE_PAY === 'waiting_confirm'" class="text-center text-danger m-3">
              อยู่ระหว่างการตรวจสอบการชำระเงิน</p>
          </div>
          <div *ngIf="modalData.ROLE !== 'user'">
            <button (click)="indeptReport(report.TEMPLATE_NOTFREE_TYPE)" class="btn mt-2"
              style="background: #060E9F; color: #FFF; width: 100px; height: 40px;">
              ดู
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- free report -->
  <div *ngIf="report.TEMPLATE_NOTFREE_TYPE === null && report.TEMPLATE_FREE_TYPE !== null" class="container">
    <div class="row justify-content-center mb-4" style="min-height: 200px;">
      <div class="col-md-8 col-12 text-center">
        <div class="height-center">
          <h5 class="text-center">รายงานผลเบื้องต้น</h5>
          <p *ngIf="report.REPORT_DES_FREE" [matTooltip]="report.REPORT_DES_FREE" matTooltipPosition="right"
            style="font-size: smaller; color: #A90088; text-decoration: underline; cursor: pointer; margin-right: 87px; margin-top: -10px;">
            คำอธิบาย</p>
          <button (click)="preliminaryReport(report.TEMPLATE_FREE_TYPE)" class="btn btn-success mt-2"
            style="color: #FFF; width: 100px; height: 40px;">
            ฟรี
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- paid report -->
  <div *ngIf="report.TEMPLATE_NOTFREE_TYPE !== null && report.TEMPLATE_FREE_TYPE === null" class="container">
    <div class="row justify-content-center mb-4" style="min-height: 200px;">
      <div class="col-md-8 col-12 text-center">
        <div class="height-center">
          <h5 class="text-center">รายงานผลเชิงลึก</h5>
          <p *ngIf="report.REPORT_DES_NOTFREE" [matTooltip]="report.REPORT_DES_NOTFREE" matTooltipPosition="right"
            style="font-size: smaller; color: #A90088; text-decoration: underline; cursor: pointer; margin-right: 87px; margin-top: -10px;">
            คำอธิบาย</p>
          <div *ngIf="modalData.ROLE === 'user'">
            <button
              *ngIf="report.STATUS_NOTFREE_PAY === 'waiting_pay' || report.STATUS_NOTFREE_PAY === 'reject' || report.STATUS_NOTFREE_PAY === 'cancel'"
              (click)="paid()" class="btn mt-2" style="background: #DE5C8E; color: #FFF; width: 100px; height: 40px;">
              {{ report.PRICE | number }}฿
            </button>
            <button *ngIf="report.STATUS_NOTFREE_PAY === 'success'" (click)="indeptReport(report.TEMPLATE_NOTFREE_TYPE)"
              class="btn mt-2" style="background: #060E9F; color: #FFF; width: 100px; height: 40px;">
              ดู
            </button>
            <button *ngIf="report.STATUS_NOTFREE_PAY === 'waiting_confirm'" class="btn mt-2"
              style="background: #DE5C8E; color: #FFF; width: 100px; height: 40px;" disabled>
              {{ report.PRICE | number }}฿
            </button>
            <p *ngIf="report.STATUS_NOTFREE_PAY === 'waiting_confirm'" class="text-center text-danger m-3">
              อยู่ระหว่างการตรวจสอบการชำระเงิน</p>
          </div>
          <div *ngIf="modalData.ROLE !== 'user'">
            <button (click)="indeptReport(report.TEMPLATE_NOTFREE_TYPE)" class="btn mt-2"
              style="background: #060E9F; color: #FFF; width: 100px; height: 40px;">
              ดู
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>